module.exports = __webpack_public_path__ + "static/media/c1.fa36dc98.jpg";